import type { Program } from "@hybrid-iptv/types";
import type { NowInfo } from "../epg/nowInfo.js";

const time = (iso: string) => new Date(iso).toLocaleTimeString([], { hour: "numeric", minute: "2-digit" });

/**
 * The remote's Info button in live full screen: the channel, what is on now
 * (time, how far in, what it is about) and what is next (owner, 2026-10-06:
 * "program info ... only brings up the toolbars with no info"). Opened and
 * closed by PlayerSurface: Info again, Back or OK put it away; a channel change
 * shows the new channel's.
 */
export function FullscreenInfo({ info, channelName }: { info: NowInfo | null; channelName: string }) {
  const channel = info?.channel;
  return (
    <div className="player-info" role="region" aria-label="Programme info">
      <div className="player-info__channel">
        {channel?.number ? <span className="player-info__number">{channel.number}</span> : null}
        {channel?.name ?? channelName}
      </div>
      {info?.now ? <Now program={info.now} /> : <p className="player-info__none">No programme information for this channel.</p>}
      {info?.next && (
        <div className="player-info__next">
          <span className="player-info__next-label">Next</span> {time(info.next.start)} · {info.next.title}
        </div>
      )}
    </div>
  );
}

function Now({ program }: { program: Program }) {
  const start = Date.parse(program.start);
  const end = Date.parse(program.end);
  const done = end > start ? Math.min(1, Math.max(0, (Date.now() - start) / (end - start))) : 0;
  return (
    <>
      <div className="player-info__title">{program.title}</div>
      {program.subtitle && <div className="player-info__subtitle">{program.subtitle}</div>}
      <div className="player-info__time">
        {time(program.start)} – {time(program.end)}
        <span className="player-info__bar" aria-hidden="true">
          <span style={{ width: `${Math.round(done * 100)}%` }} />
        </span>
      </div>
      {program.description && <p className="player-info__desc">{program.description}</p>}
    </>
  );
}
